export default __webpack_public_path__ + "static/media/DiyaKaran_Nobg.e1f28ced.png";